__turbopack_context__.v({
  "arrowBadge": "Q-rwDa_arrowBadge",
  "card": "Q-rwDa_card",
  "dateText": "Q-rwDa_dateText",
  "foot": "Q-rwDa_foot",
  "pill": "Q-rwDa_pill",
  "pillLabel": "Q-rwDa_pillLabel",
  "readLabel": "Q-rwDa_readLabel",
  "swatch": "Q-rwDa_swatch",
  "title": "Q-rwDa_title",
  "top": "Q-rwDa_top",
});
